module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1224.217ab125.png";